import { createBrowserHistory } from 'history';
import settings from './conf'

const history = createBrowserHistory({ basename: settings.BASE_NAME});
export default history;
